import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RpUtilitiesComponent } from './rp-utilities/rp-utilities.component';
import { RpUnitRateHistoryComponent } from './rp-unit_rate_history/rp-unit_rate_history.component';
import { RpHistotyUnitRateComponent } from './rp-histoty-unit-rate/rp-histoty-unit-rate.component';
import { RpCreateEvMeterComponent } from './rp-create-ev-meter/rp-create-ev-meter.component';

const routes: Routes = [
  { path: 'utilities', component: RpUtilitiesComponent },
  { path: 'utilities/createEVMeter', component: RpCreateEvMeterComponent },
  // { path: 'unitratehistory', component: RpUnitRateHistoryComponent },
  { path: 'unitratehistory', component: RpHistotyUnitRateComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UtilitiesRoutingModule { }
